const OktaConfig = {
  adminSecret: process.env.OKTA_ADMIN_SECRET,
  adminToken: process.env.OKTA_ADMIN_TOKEN,
  apiUrl: process.env.NEXT_PUBLIC_OKTA_API,
  clientId: process.env.OKTA_CLIENT_ID,
  clientSecret: process.env.OKTA_CLIENT_SECRET,
  issuer: process.env.NEXT_PUBLIC_ORG_URL,
};

export default OktaConfig;
